import React from "react";
import Seo from "../components/Seo";
import "../style/style-pages/legal-page.css";

const Privacy = () => (
    <main className="legal-page">
        <Seo
            canonicalPath="/privacy"
            description="Learn which essential form and optional analytics services are used on the WiseCursor website and how to manage analytics preferences."
            title="Privacy Notice"
        />
        <div className="container legal-page__content">
            <p className="legal-page__eyebrow">Privacy</p>
            <h1>WiseCursor website privacy notice</h1>
            <p>This notice describes the services currently configured on this website. It does not replace any additional terms presented by a form or third-party service.</p>
            <h2>Contact form</h2>
            <p>The contact form is provided through Deftform and protected by reCAPTCHA. Information entered there is sent only when you submit the form.</p>
            <h2>Optional analytics</h2>
            <p>Google Analytics, Hotjar, Microsoft Clarity, Capturly, Amplitude Session Replay, and the Gloria chat tool remain disabled until you select “Accept analytics.” These services help WiseCursor understand visits, interactions, support visitors, and identify opportunities to improve the experience.</p>
            <h2>Your choice</h2>
            <p>You can decline optional analytics and continue using the site. Use “Cookie preferences” in the footer to review or change the stored choice on this browser.</p>
            <h2>Contact</h2>
            <p>Questions about this notice can be sent to <a href="mailto:info@wisecursor.com">info@wisecursor.com</a>.</p>
        </div>
    </main>
);

export default Privacy;
